import script from "./mineralTypeId.vue?vue&type=script&setup=true&lang=js"
export * from "./mineralTypeId.vue?vue&type=script&setup=true&lang=js"

import "./mineralTypeId.vue?vue&type=style&index=0&id=7704370e&lang=scss"

const __exports__ = script;

export default __exports__